var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"Store/form","endpoint":"stores","aditionalColumns":_vm.headers,"inlineToggle":"","hideDelete":""}},[[_c('h1',[_vm._v("Cadastro de Lojas")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }